import { createContext,useEffect,useState } from 'react'
import { get } from '../lib/api'
import { getLocale } from '../lib/i18n'
import type { Item } from '../../shared/market/model'

/** Card titles in the reader's language. Asked once per title and language, then remembered. */
export const CardTitleContext=createContext<Record<string,string>>({})
const known=new Map<string,string|null>()
const asked=new Set<string>()

export function useCardTitles(items:Item[]):Record<string,string>{
 const [,tick]=useState(0)
 const locale=getLocale(),key=items.map(x=>x.id).join(',')
 useEffect(()=>{
  const want=items.map(x=>x.id).filter(id=>!asked.has(`${locale}:${id}`))
  if(!want.length)return
  let alive=true
  for(let i=0;i<want.length;i+=30){
   const chunk=want.slice(i,i+30);chunk.forEach(id=>asked.add(`${locale}:${id}`))
   get<{titles:Record<string,string>}>(`/api/market/translations?ids=${chunk.join(',')}&to=${encodeURIComponent(locale)}`).then(r=>{chunk.forEach(id=>known.set(`${locale}:${id}`,r.titles[id]??null));if(alive)tick(n=>n+1)}).catch(()=>{chunk.forEach(id=>asked.delete(`${locale}:${id}`))})
  }
  return()=>{alive=false}
 // eslint-disable-next-line react-hooks/exhaustive-deps
 },[key,locale])
 return Object.fromEntries(items.flatMap(x=>{const t=known.get(`${locale}:${x.id}`);return t?[[x.id,t]]:[]}))
}
